<div class="search-result" [ngClass]="backgroundClass">
    <div class="result-header">
        <div class="result-type-badge location">
            <mat-icon>place</mat-icon>
            <span class="badge-label">Location</span>
        </div>
        <div class="action-buttons" (click)="$event.stopPropagation()">
            <button
                matMiniFab
                color="primary"
                matTooltip="Branch Location Grid"
                (click)="$event.stopPropagation(); gridButton()"
                [routerLink]="'datamaintenance/stoplocations'"
                [queryParams]="{ GroupID: item().GroupID }">
                <mat-icon class="no-margin">place</mat-icon>
            </button>
        </div>
        @if (locationStatus.text) {
            <div class="status-badge" [ngClass]="'status-' + locationStatus.level">
                {{ locationStatus.text }}
            </div>
        }
    </div>

    <div class="result-primary">
        <div class="result-id" [highlight]="searchTerm()">{{ primaryId }}</div>
        @if (item().Note) {
            <div class="warning-message">
                <mat-icon>edit_note</mat-icon>
                {{ item().Note }}
            </div>
        }
    </div>

    <div class="result-details location-details">
        @if (fullAddress) {
            <div class="detail-row">
                <div class="detail-item">
                    <mat-icon class="detail-icon">place</mat-icon>
                    <span class="detail-value" [highlight]="searchTerm()">{{ fullAddress }}</span>
                    <mat-icon class="detail-icon">schedule</mat-icon>
                    <span class="detail-value">{{ item().TimeZoneOffset | timezoneOffset }}</span>
                </div>
            </div>
        }

        @if (item().Phone) {
            <div class="detail-row">
                <div class="detail-item">
                    <span class="detail-label text-muted">Phone:</span>
                    <span class="detail-value">{{ item().Phone | tel }}</span>
                    @if (item().PhoneExt) {
                        <span class="detail-value">x{{ item().PhoneExt }}</span>
                    }
                </div>
            </div>
        }

        @if (item().Email) {
            <div class="detail-row">
                <div class="detail-item">
                    <span class="detail-label text-muted">Email:</span>
                    <span class="detail-value">{{ item().Email }}</span>
                </div>
            </div>
        }

        @if (item().Instructions) {
            <div class="detail-grid instruction-info">
                <div class="detail-item">
                    <span class="detail-label">
                        <mat-icon class="detail-icon">info</mat-icon>
                        <span class="detail-label">Instructions:</span>
                    </span>
                    <span class="detail-value">{{ item().Instructions }}</span>
                </div>
            </div>
        }
    </div>
</div>
